import React, { useState } from "react";
import {
  Box,
  Typography,
  Container,
  Button,
  Stack,
  Card,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";

import EMICalculator from "../components/Emicalculator";
import { color, motion } from "framer-motion";
import SendIcon from "@mui/icons-material/Send";
import TouchAppIcon from "@mui/icons-material/TouchApp";
import AssignmentIcon from "@mui/icons-material/Assignment";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import PriceCheckIcon from "@mui/icons-material/PriceCheck";
import LoanPopupForm from "../components/PopupForm";
import FAQSection from "../components/FaqComponent";
import CallBackForm from "../components/CallBackForm";
import Find from "../assets/images/find.webp";
import MiniCar from "../assets/images/mini-car.gif";
import tractor from "../assets/images/tractor.gif";
import pickup from "../assets/images/pickup.gif";
import truck from "../assets/home/business_loans.gif";
import Lottie from "lottie-react";
import greenLoansLottie from "../assets/green-loans-lottie.json";
import businessLoansLottie from "../assets/business-loans-lottie.json";
import whatweare from "../assets/home/psn_100.avif";
import arrowright from "../assets/images/arrow-right.webp";
import flexible from "../assets/images/flexible.svg";
import instant from "../assets/images/instant.svg";
import lower from "../assets/images/lower.svg";
import secure from "../assets/images/quick.svg";
import testimonial1 from "../assets/images/testimonial-1.webp";
import testimonial2 from "../assets/images/testimonial-2.webp";
// import testimonial3 from "../assets/images/testimonial-3.webp";
// import testimonial4 from "../assets/images/testimonial-4.webp";
import testimonial5 from "../assets/images/driver.webp";
import testimonial6 from "../assets/images/construction.webp";

import cardbg from "../assets/images/cardbg.webp";
import HeroSlider from "../components/HomePageSlider";
// import hero1 from "../assets/images/slide-v-1.webp";
// import hero2 from "../assets/images/slide-v-2.webp";

import hero1 from "../assets/home/hero1.avif";
import hero11 from "../assets/home/hero11.avif";
import hero21 from "../assets/home/hero21.avif";

import hero33 from "../assets/home/hero33.png";
import hero43 from "../assets/home/hero43.jpeg";

import { Link } from "react-router-dom";
import { paths } from "../routes/path";
import SeoComponent from "../components/SeoComponent";

const faqData = [
  {
    id: "panel1",
    question: `How can a I get adjustment of excess EMI paid?`,

    answer:
      "If you've paid extra EMI, it will be adjusted against your upcoming payments or refunded to your registered bank account after verification.",
  },
  {
    id: "panel2",
    question: "What are the modes of EMI payment?",
    answer:
      "You can pay EMIs through auto-debit, online banking, mobile wallets, UPI, or by visiting our branch.",
  },
  // {
  //   id: "panel3",
  //   question: "What does PDD stands for?",
  //   answer:
  //     "PDD stands for Post Dated Document, usually referring to cheques or documents submitted for future payments.",
  // },
  {
    id: "panel4",
    question: "How can a customer report a fraud?",
    answer:
      "Immediately contact our customer care helpline or visit your nearest branch to report the incident, so we can take prompt action.",
  },
];

const imagesHero = [
  // --- 1. Used Commercial Vehicle slides ---
  {
    image: hero11,
    title1: "Keep Your Business Moving",
    title2: "with Used Vehicle Loans",
    path: paths.dashboard.commercialVehicleLoan,
    discription:
      "Reliable financing for pre-owned trucks, tippers, pickups, trailers, and transport vehicles with quick approvals.",
  },
  // {
  //   image: hero12,
  //   title1: "Keep Your Business Moving",
  //   title2: "with Used Vehicle Loans",
  //   path: paths.dashboard.commercialVehicleLoan,
  //   discription: "Reliable financing for pre-owned trucks, tippers, pickups, trailers, and transport vehicles with quick approvals.",
  // },
  // {
  //   image: hero13,
  //   title1: "Keep Your Business Moving",
  //   title2: "with Used Vehicle Loans",
  //   path: paths.dashboard.commercialVehicleLoan,
  //   discription: "Reliable financing for pre-owned trucks, tippers, pickups, trailers, and transport vehicles with quick approvals.",
  // },
  // --- 2. Used Tractor Loan slides ---
  {
    image: hero21,
    title1: "Power Your Agriculture",
    title2: "with Used Tractor Loan",
    path: paths.dashboard.usedTractorFinance,
    discription:
      "Get easy financing for used tractors with quick approvals, low interest rates, and flexible EMIs.",
  },
  // {
  //   image: hero22,
  //   title1: "Power Your Agriculture",
  //   title2: "with Used Tractor Loan",
  //   path: paths.dashboard.usedTractorFinance,
  //   discription:
  //     "Get easy financing for used tractors with quick approvals, low interest rates, and flexible EMIs.",
  // },
  // {
  //   image: hero23,
  //   title1: "Power Your Agriculture",
  //   title2: "with Used Tractor Loan",
  //   path: paths.dashboard.usedTractorFinance,
  //   discription:
  //     "Get easy financing for used tractors with quick approvals, low interest rates, and flexible EMIs.",
  // },
  // --- 3. Used Car Loan slides ---
  {
    image: hero1,
    title1: "Drive Your Dream Car",
    title2: "with Used Car Loans",
    path: paths.dashboard.carloan,
    discription:
      "Easy financing for certified pre-owned cars with competitive interest rates and hassle-free approvals.",
  },
  // {
  //   image: hero2,
  //   title1: "Drive Your Dream Car",
  //   title2: "with Used Car Loans",
  //   path: paths.dashboard.carloan,
  //   discription:
  //     "Easy financing for certified pre-owned cars with competitive interest rates and hassle-free approvals.",
  // },
  // {
  //   image: hero3,
  //   title1: "Drive Your Dream Car",
  //   title2: "with Used Car Loans",
  //   path: paths.dashboard.carloan,
  //   discription:
  //     "Easy financing for certified pre-owned cars with competitive interest rates and hassle-free approvals.",
  // },
  // --- 4. EV / Green Loan slides ---
  // {
  //   image: hero31,
  //   title1: "Finance a Greener Tomorrow",
  //   title2: "with Green Loans",
  //   path: paths.dashboard.evCarLoan,
  //   discription:
  //     "Flexible financing for electric 3-wheelers, cars, and trucks with fast disbursal and competitive interest rates.",
  // },
  // {
  //   image: hero32,
  //   title1: "Finance a Greener Tomorrow",
  //   title2: "with Green Loans",
  //   path: paths.dashboard.evCarLoan,
  //   discription:
  //     "Flexible financing for electric 3-wheelers, cars, and trucks with fast disbursal and competitive interest rates.",
  // },
  {
    image: hero33,
    title1: "Finance a Greener Tomorrow",
    title2: "with Green Loans",
    path: paths.dashboard.evCarLoan,
    discription:
      "Flexible financing for electric 3-wheelers, cars, and trucks with fast disbursal and competitive interest rates.",
  },
  // --- 5. Business Loan slides ---
  // {
  //   image: hero41,
  //   title1: "Grow Your Business",
  //   title2: "with Business Loan",
  //   path: paths.dashboard.usedBusinessLoan,
  //   discription:
  //     "Quick business loans to manage working capital, expand operations, or invest in growth.",
  // },
  // {
  //   image: hero42,
  //   title1: "Grow Your Business",
  //   title2: "with Business Loan",
  //   path: paths.dashboard.usedBusinessLoan,
  //   discription:
  //     "Quick business loans to manage working capital, expand operations, or invest in growth.",
  // },
  {
    image: hero43,
    title1: "Grow Your Business",
    title2: "with Business Loan",
    path: paths.dashboard.usedBusinessLoan,
    discription:
      "Quick business loans to manage working capital, expand operations, or invest in growth.",
  },
];

const criteria = [
  { label: "Nationality", value: "Indian citizen" },
  { label: "Age", value: "Between 21 - 60 years." },
  { label: "Documentation", value: "Valid ID and address proof mandatory." },
  {
    label: "Profile",
    value: "Salaried, Self-Employed, Small business owners & MSMEs.",
  },
];

const callBackFormLabels = "Home Loan Call Back Form";

const cardData = [
  {
    title: "Choose Loan Type",
    description:
      "Select the loan category that best matches your financial needs and goals.",
  },
  {
    title: "Complete Application",
    description:
      "Fill out the required information carefully to ensure a smooth approval process.",
  },
  {
    title: "Submit Documents",
    description:
      "Provide accurate and verified documents for identity and income verification.",
  },
  {
    title: "Get Approved & Disbursed",
    description:
      "Once verified, receive quick approval and disbursal directly to your account.",
  },
];

const testimonials = [
  {
    image: testimonial1,
    color: "rgb(238, 245, 255)",
    quote:
      "PSN Finance made my car loan process smooth and hassle-free. The quick approval and transparent terms gave me complete peace of mind.",
    name: "Rajesh Kumar",
    title: "Shimoga, Karnataka",
    marginTop: "0px",
  },
  {
    image: testimonial2,
    color: "rgb(255, 250, 230)",
    quote:
      "⁠ ⁠With their housing loan, building my dream home became a reality. The team guided me at every step with clarity and support.",
    name: "Anita R.",
    title: " Bangalore",
    marginTop: "40px",
  },
  {
    image: testimonial5,

    color: "rgb(251, 240, 255)",
    quote:
      "Getting my truck loan approved through PSN Finance was quick and easy. The flexible EMI options helped me manage my business smoothly without any financial strain.",
    name: "Ramesh K",
    title: "Mangalore",
    marginTop: "0px",
  },
  {
    image: testimonial6,
    color: "rgb(255, 240, 241)",
    quote:
      "I purchased a new excavator with the help of PSN Finance. Their team understood my needs and processed the loan on time, helping me take up bigger projects with confidence.",
    name: "Suresh P",
    title: "Mysore",
    marginTop: "40px",
  },
];

const Home = () => {
  const [flippedCard, setFlippedCard] = useState(null);
  const [hoveredBox, setHoveredBox] = React.useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const cardData = [
    {
      step: "01",
      backgroundColor: "#fff",
      accentColor: "#043694",
      title: (
        <>
          Choose
          <br />
          Loan Type
        </>
      ),
      description: "Choose a loan tailored to your needs.",
      icon: <TouchAppIcon sx={{ color: "#fff", fontSize: 26 }} />,
    },
    {
      step: "02",
      title: "Complete Application",
      backgroundColor: "#fff",
      accentColor: "#00cc87",
      description: "Fill out the application with accurate details.",
      icon: <AssignmentIcon sx={{ color: "#fff", fontSize: 26 }} />,
    },
    {
      step: "03",
      title: "Submit Documents",
      backgroundColor: "#fff",
      accentColor: "#043694",
      description: "Upload valid documents for quick verification.",
      icon: <FileUploadIcon sx={{ color: "#fff", fontSize: 26 }} />,
    },
    {
      step: "04",
      title: "Approval & Disbursal",
      backgroundColor: "#fff",
      accentColor: "#00cc87",
      description: "Once approved, funds are disbursed to your bank account.",
      icon: <PriceCheckIcon sx={{ color: "#fff", fontSize: 28 }} />,
    },
  ];

  return (
    <Box>
      <SeoComponent
        title="PSN Finance | Smart Loan Solutions for Every Need"
        description="Discover trusted loan and finance options with PSN Finance. From vehicles to housing and personal loans, we help you achieve your goals with flexible plans."
        keywords="loan solutions, vehicle loans, home loans, business loans, flexible EMIs, quick loan approval, trusted finance"
      />

      {/* Hero Section */}
      <HeroSlider imagesHero={imagesHero} />

      {/* Products Section */}
      <Container
        maxWidth="lg"
        sx={{ pb: 0, maxWidth: "100%", px: { xs: 2, md: 0 } }}
      >
        <Typography
          variant="h2"
          sx={{
            display: { xs: "block", md: "none" },
            fontFamily: "Inter, sans-serif",
            fontSize: { xs: "2rem", md: "3rem" },
            fontWeight: 600,
            color: "#000",
            textAlign: "center",
            mb: { xs: 0, md: 1 },
            mt: { xs: 4, md: 8 },
          }}
        >
          Our <span style={{ color: "#0265fe" }}>Products</span>
        </Typography>

        <Container maxWidth="lg" sx={{ py: 4, maxWidth: "100%" }}>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "center",
              maxWidth: "100%",
              gap: { xs: 2, md: 2 },
            }}
          >
            {[
              {
                img: pickup,
                background: "#eef5ff",
                title: "Used Commercial\nVehicle Loans",
                subtitle: "New & Used Vehicles",
                path: paths.dashboard.commercialVehicleLoan,
              },
              {
                img: tractor,
                background: "#f5fff3",
                title: "Used Tractor Loans",
                subtitle: "Business Equipment",
                path: paths.dashboard.usedTractorFinance,
              },
              {
                img: MiniCar,
                title: "Used Car Loans",
                background: "#fff0f1",
                subtitle: "New & Used Vehicles",
                path: paths.dashboard.carloan,
              },
              {
                lottieData: greenLoansLottie,
                title: "Green Loans",
                background: "#fffae6",
                subtitle: "Purchase & Construction",
                path: paths.dashboard.ev3WheelerLoan,
              },
              {
                lottieData: businessLoansLottie,
                background: "#fbf0ff",
                title: "Business loans",
                subtitle: "Business Expansion",
                path: paths.dashboard.usedBusinessLoan,
              },
            ].map((item, index) => (
              <Link
                to={item?.path}
                style={{ textDecoration: "none" }}
                sx={{ width: "100%" }}
              >
                <Box
                  key={index}
                  sx={{
                    //           background: `radial-gradient(circle at top right, rgba(240, 243, 255, 0.8) 0%, rgba(255, 255, 255, 1) 40%),
                    //  radial-gradient(circle at bottom left, rgba(240, 243, 255, 0.8) 0%, rgba(255, 255, 255, 1) 40%)`,
                    backgroundColor: item.background,
                    borderRadius: "8px",
                    padding: isMobile ? "15px" : "30px",
                    // border: "0.5px solid #e0e0e0",
                    display: "flex",

                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    width: isMobile ? "100%" : "100%",
                    height: isMobile ? "180px" : "240px",
                    mx: isMobile && index === 4 ? "auto" : "unset", // center last card on mobile
                    "&:hover": {
                      cursor: "pointer",
                    },
                  }}
                >
                  {item.lottieData ? (
                    <Box
                      sx={{
                        width: isMobile ? "60px" : "120px",
                        height: isMobile
                          ? "60px"
                          : index === 0
                            ? "130px"
                            : "107px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Lottie animationData={item.lottieData} loop={true} />
                    </Box>
                  ) : (
                    <img
                      src={item.img}
                      alt="Animated Finance Graphic"
                      style={{
                        width: isMobile ? "60px" : "120px",
                        height: isMobile
                          ? "60px"
                          : index === 0
                            ? "130px"
                            : "107px",
                        marginTop: "0",
                        objectFit: "contain",
                      }}
                    />
                  )}
                  <Typography
                    sx={{
                      color: "#000",
                      fontSize: isMobile ? "12px" : "16px",
                      fontWeight: 600,
                      lineHeight: 1.2,
                      mt: isMobile ? 1 : 2.5,
                      fontFamily: "Inter, sans-serif",
                      textAlign: "center",
                      whiteSpace: "pre-line",
                    }}
                  >
                    {item.title}
                  </Typography>
                </Box>
              </Link>
            ))}
          </Box>
        </Container>
      </Container>

      {/* what we are section */}

      <Container
        maxWidth="lg"
        sx={{ py: { xs: 6, md: 8 }, pt: { xs: 1, md: 8 } }}
      >
        <Stack
          direction={{ xs: "column", md: "row" }}
          alignItems="center"
          justifyContent="center"
          spacing={3}
        >
          <Box
            sx={{
              width: { xs: "100%", md: "50%" },
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
            }}
          >
            <img
              src={whatweare}
              alt="What We Are"
              width={isMobile ? "50%" : "75%"}
            />
          </Box>
          <Box sx={{ width: { xs: "100%", md: "50%" } }}>
            <Typography
              variant="h2"
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: isMobile ? "1.8rem" : "3rem",
                fontWeight: 600,
                color: "#000",
                mt: { xs: -3 },
                mb: { xs: 2, md: 2 },
                textAlign: { xs: "center", md: "left" },
              }}
            >
              Who <span style={{ color: "#0265fe" }}>We Are</span>
            </Typography>

            {/* Mobile image - appears after heading */}
            <Box
              sx={{
                width: "100%",
                display: { xs: "flex", md: "none" },
                justifyContent: "center",
                mb: 3,
              }}
            >
              <img src={whatweare} alt="What We Are" width="50%" />
            </Box>

            <Typography
              variant="body1"
              sx={{
                fontSize: isMobile ? "15px" : "18px",
                color: "#000",
                lineHeight: 1.2,
                fontFamily: "Inter, sans-serif",
                fontWeight: 300,
                textAlign: { xs: "center", md: "justify" },
              }}
            >
              PSN Finance is a regionally focused auto ecosystem lender
              incubated from legacy vehicle dealership operations. We are a
              Bangalore-based startup NBFC focused on the vehicle financing
              space. We are part of the 100+ year old PSN Group, which has
              commercial vehicle and construction equipment dealerships, spare
              parts distribution and service operations across South India.
              <br />
              <br />
              PSN Finance is conceived as an extension of the PSN ecosystem
              which serves the commercial vehicle driver turned operator. We
              help make vehicle financing accessible and reliable across the
              spectrum - from first-time borrowers to fleet operators - by
              leveraging our legacy operations that have taught us ecosystem,
              and with AI and tech-enablement to drive origination, underwriting
              and collections.
            </Typography>

            <Stack
              direction="row"
              alignItems="center"
              justifyContent={{ xs: "center", md: "space-between" }}
              spacing={2}
              sx={{ mt: 1 }}
            >
              <Link
                to={paths.dashboard.aboutUs}
                style={{ textDecoration: "none", marginTop: "0" }}
              >
                <Button
                  variant="contained"
                  endIcon={
                    <img
                      src={arrowright}
                      alt="Arrow Right"
                      style={{ width: "12px", height: "12px" }}
                    />
                  }
                  sx={{
                    backgroundColor: "#00cc87",
                    color: "white",
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "14px",
                    px: 3,
                    py: 0.5,
                    mt: 1,
                    borderRadius: "8px",
                    "&:hover": {
                      backgroundColor: "#0265fe",
                      transform: "translateY(-2px)",
                    },
                  }}
                >
                  Read Story
                </Button>
              </Link>
            </Stack>
          </Box>
        </Stack>
      </Container>

      {/* Why Choose PSN Finance section */}

      <Container maxWidth="lg" sx={{ pt: 0, pb: 2 }}>
        <Typography
          variant="h2"
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: isMobile ? "1.6rem" : "3rem",
            fontWeight: 600,
            color: "#000",
            textAlign: "center",
            mb: { xs: 5, md: 3 },
          }}
        >
          Why Choose <span style={{ color: "#0265fe" }}>PSN Finance</span>
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", md: "nowrap" },
            justifyContent: "center",
            gap: { xs: 2, md: 7 },
            mb: { xs: 3 },
          }}
        >
          {[
            { img: flexible, text: "Financial Inclusion" },
            { img: instant, text: "Vehicle Lifecycle Support" },
            { img: lower, text: "Hyper Local" },
            // { img: secure, text: "Quick\nDisbursals" },
          ].map((item, index) => (
            <Box
              key={index}
              sx={{
                width: isMobile ? "calc(50% - 8px)" : "25%",
                p: 2,
                border: "0.5px solid #eee",
                borderRadius: "8px",
              }}
            >
              <Box
                sx={{
                  backgroundColor: "#F9FAFF",
                  p: isMobile ? "30px 15px" : "50px 20px",
                  borderRadius: "8px",
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <img
                  src={item.img}
                  alt="Why Choose PSN"
                  width={isMobile ? "50px" : "70px"}
                  height={isMobile ? "50px" : "70px"}
                />
                <Typography
                  variant="body2"
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: isMobile ? "14px" : "16px",
                    fontWeight: 500,
                    color: "#606060",
                    textAlign: "center",
                    mt: 2,
                    whiteSpace: "pre-line",
                  }}
                >
                  {item.text}
                </Typography>
              </Box>
            </Box>
          ))}
        </Box>
      </Container>

      {/* criteria Section */}
      <Box
        sx={{
          mb: 5,
        }}
      >
        <Container
          maxWidth="lg"
          sx={{
            pt: 2,
            pb: 2,
          }}
        >
          <Box
            sx={{
              pb: 2,
              pt: 2,
              display: "flex",
              flexDirection: { xs: "row", md: "column" },
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: { xs: "1.5rem", md: "3rem" },
                fontWeight: 600,
                color: "#0265fe",
                textAlign: "center",
              }}
            >
              How to apply <span style={{ color: "#000" }}> for loan?</span>
            </Typography>
          </Box>
          <Stack
            direction={isMobile ? "column" : "row"}
            spacing={isMobile ? 3 : 4}
            justifyContent="center"
            alignItems="stretch"
            sx={{
              py: 2,
              px: 3,
            }}
          >
            {cardData.map((card, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  duration: 0.6,
                  delay: index * 0.3, // Increased delay for better one-by-one effect
                  ease: "easeOut",
                }}
                whileHover={{
                  scale: 1.05,
                  transition: { duration: 0.2 },
                }}
                style={{
                  flex: 1,
                  borderRadius: "24px",
                  backgroundColor: card?.backgroundColor,
                  padding: "32px 24px",
                  textAlign: "left",
                  cursor: "pointer",
                  border: "1px solid #e0e0e0",
                  boxShadow: `0px 8px 0px 0px ${card?.accentColor || "#043694"}`,
                  marginBottom: "8px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    mb: 2,
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        fontSize: isMobile ? "32px" : "40px",
                        fontWeight: 800,
                        fontFamily: "Inter, sans-serif",
                        color: card?.accentColor || "#043694",
                        lineHeight: 1,
                      }}
                    >
                      {card.step}
                    </Typography>
                    <Box
                      sx={{
                        width: "100%",
                        height: "2px",
                        backgroundColor: card?.accentColor || "#043694",
                        mt: 1,
                        opacity: 0.5,
                      }}
                    />
                  </Box>
                  <Box
                    sx={{
                      width: 48,
                      height: 48,
                      minWidth: 48,
                      borderRadius: "50%",
                      backgroundColor: card?.accentColor || "#043694",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    {card.icon}
                  </Box>
                </Box>

                <Typography
                  variant="h6"
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 700,
                    color: "#1A202C",
                    mb: 1.5,
                    fontSize: isMobile ? "1.2rem" : "1.4rem",
                    lineHeight: 1.2,
                  }}
                >
                  {card.title}
                </Typography>

                <Typography
                  variant="body1"
                  sx={{
                    fontSize: isMobile ? "15px" : "16px",
                    color: "#5a5a5a",
                    lineHeight: 1.5,
                    fontFamily: "Inter, sans-serif",
                    fontWeight: 400,
                  }}
                >
                  {card.description}
                </Typography>
              </motion.div>
            ))}
          </Stack>
        </Container>
      </Box>

      <Container
        maxWidth="lg"
        sx={{ py: { xs: 1, md: 8 }, px: isMobile ? 0 : 4 }}
      >
        <Typography
          variant="h2"
          sx={{
            fontFamily: "Inter, sans-serif",
            fontSize: isMobile ? "2rem" : "3rem",
            fontWeight: 600,
            color: "#000",
            textAlign: "center",
            mb: 3,
          }}
        >
          PSN Group Is <span style={{ color: "#0265fe" }}>Always With You</span>
        </Typography>

        <Box
          sx={{
            display: "flex",
            flexWrap: { xs: "wrap", md: "nowrap" },
            justifyContent: "center",
            gap: { xs: 1, md: 3 },
            px: isMobile ? 0 : 4,
          }}
        >
          {testimonials.map((testimonial, index) => (
            <Box
              key={index}
              sx={{
                width: { xs: "calc(50% - 8px)", md: "25%" },
                perspective: "1000px",
                height: isMobile ? "280px" : "320px",
                mb: 0,
                display: isMobile && index > 3 ? "none" : "block",
                boxSizing: "border-box",
              }}
              onMouseEnter={() => setFlippedCard(index)}
              onMouseLeave={() => setFlippedCard(null)}
            >
              <Card
                sx={{
                  width: "100%",
                  height: "100%",
                  mt: isMobile ? 0 : testimonial?.marginTop,
                  position: "relative",
                  transformStyle: "preserve-3d",
                  transition: "transform 0.7s ease-in-out",
                  transform:
                    flippedCard === index ? "rotateY(180deg)" : "rotateY(0deg)",
                  cursor: "pointer",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.15)",
                  borderRadius: "12px",
                  backgroundColor: "transparent",
                  overflow: "visible",
                }}
              >
                <Box
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backfaceVisibility: "hidden",
                    WebkitBackfaceVisibility: "hidden",
                    backgroundImage: `url(${testimonial?.image})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px",
                    backgroundRepeat: "no-repeat",
                    zIndex: 2,
                  }}
                />

                <Box
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backfaceVisibility: "hidden",
                    WebkitBackfaceVisibility: "hidden",
                    // backgroundImage: `url(${cardbg})`,
                    backgroundColor: testimonial?.color,
                    transform: "rotateY(180deg)",
                    borderRadius: "12px",
                    padding: isMobile ? "16px" : "24px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    color: "white",
                    boxSizing: "border-box",
                    zIndex: 1,
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      marginBottom: isMobile ? "16px" : "24px",
                      fontStyle: "italic",
                      lineHeight: 1.6,
                      fontSize: isMobile ? "12px" : "14px",
                      fontWeight: 500,
                      color: "#000",
                    }}
                  >
                    "{testimonial.quote}"
                  </Typography>

                  <Box sx={{ marginTop: isMobile ? "12px" : "16px" }}>
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: "bold",
                        marginBottom: "8px",
                        fontSize: isMobile ? "16px" : "18px",
                        color: "#000",
                      }}
                    >
                      {testimonial.name}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        opacity: 0.9,
                        fontSize: isMobile ? "11px" : "12px",
                        color: "#000",
                      }}
                    >
                      {testimonial.title}
                    </Typography>
                  </Box>
                </Box>
              </Card>
            </Box>
          ))}
        </Box>
      </Container>

      {/* EM Calculator */}
      <Box sx={{ p: isMobile ? 0 : 5 }}>
        <EMICalculator />
      </Box>

      <Container maxWidth="lg">
        <LoanPopupForm timeout="more" popUpId="applyNow-home-page" />
      </Container>

      {/* FAQ Section */}
      <FAQSection faqData={faqData} />

      {/* Call Back Section */}
      <Container maxWidth="lg" sx={{ py: { xs: 2, md: 8 } }}>
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          sx={{ maxWidth: "100%" }}
        >
          <Box sx={{ width: { xs: "100%", md: "50%" }, mb: isMobile ? 4 : 0 }}>
            <Typography
              variant="h2"
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: isMobile ? "2rem" : "3rem",
                fontWeight: 600,
                color: "#000",
                mb: 2,
                textAlign: { xs: "center", md: "left" },
              }}
            >
              Request a <span style={{ color: "#0265fe" }}>Call Back</span>
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Inter, sans-serif",
                fontSize: isMobile ? "14px" : "18px",
                fontWeight: 300,
                color: "#000",
                mb: 0,
                textAlign: { xs: "center", md: "left" },
              }}
            >
              Need more information or help choosing the right loan? Simply
              share your details, and our team will call you back at your
              convenience. For more information,{" "}
              <Link
                to={paths.dashboard.contactUs}
                style={{ color: "#0265fe", textDecoration: "none" }}
              >
                contact us.
              </Link>
            </Typography>
          </Box>
          <Box
            sx={{
              width: { xs: "100%", md: "50%" },
              display: "flex",
              justifyContent: "center",
            }}
          >
            <CallBackForm callBackFormLabels={callBackFormLabels} />
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default Home;
